import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';


export const MightyExclusiveTagContainer = styled.div`
  background: ${palette.snowFlower};
  border-radius: 2px;
  display: inline-block;
  margin-left: 15px;
  padding: 0 8px;
  max-width: 170px;
  height: 22px;

  > span {
    color: ${palette.white};
    font-size: 0.9rem;
    margin: 0 auto;
  }

  @media screen and (max-width: ${layout.sm}) {
    display: none;
  }
`

export const StarImageContainer = styled.div`
  display: none;
  width: 18px;
  height: 18px;
  overflow: visible;

  svg {
    margin-bottom: -4px;
  }

  @media screen and (max-width: ${layout.sm}) {
    display: inline-block;
    margin: auto 6px;
  }
`
